export type TrustpilotReviewVariant = 'share' | 'thanks'

export interface TrustpilotReviewPresentation {
  variant: TrustpilotReviewVariant
  title: string
  description: string
  notNowButtonVariant: 'default' | 'outline'
}

export interface PlatformRatingPresentation {
  feedbackPrompt: string | null
  trustpilot: TrustpilotReviewPresentation | null
}

const shareExperiencePresentation: TrustpilotReviewPresentation = {
  variant: 'share',
  title: 'Share your experience',
  description: 'This feedback is optional.',
  notNowButtonVariant: 'default',
}

const thanksForRatingPresentation: TrustpilotReviewPresentation = {
  variant: 'thanks',
  title: 'Thanks for the rating!',
  description:
    'Would you mind leaving the same review on Trustpilot? It goes a long way for us.',
  notNowButtonVariant: 'outline',
}

/**
 * Returns the platform rating experience for a selected star value.
 */
export function getPlatformRatingPresentation(
  rating: number,
  trustpilotEnabled: boolean,
): PlatformRatingPresentation {
  if (rating === 1 || rating === 2) {
    return {
      feedbackPrompt: 'Sorry we missed the mark. What went wrong?',
      trustpilot: shareExperiencePresentation,
    }
  }

  if (rating === 3) {
    return {
      feedbackPrompt: 'How could we improve your experience?',
      trustpilot: shareExperiencePresentation,
    }
  }

  if (rating === 4 || rating === 5) {
    return {
      feedbackPrompt: trustpilotEnabled ? null : 'Add a written review',
      trustpilot: thanksForRatingPresentation,
    }
  }

  return {
    feedbackPrompt: null,
    trustpilot: null,
  }
}
